import { WarrantEntity } from '../../../../types/WarrantEntity'
import { IssueEntity } from '../../../../types/IssueEntity'

export const getSectorIdFromIssueOrWarrant = ({ sectorLevel1, sectorLevel2 }: IssueEntity | WarrantEntity) => {
    return `${sectorLevel1}__${sectorLevel2}`
}

export const getSectorLevelsFromId = (sectorId: string) => sectorId.split('__') as [string, string?]
